'use strict'

export function isIphoneX() {
  return /iphone/gi.test(navigator.userAgent) && ((screen.height == 812 && screen.width == 375) || (screen.height == 896 && screen.width == 414))
}

export function isWeibo () {
  const isWeibo = !!u.match(/WeiBo/i)
  return isWeibo
}

export function isQQ () {
  const isQQ = !!u.match(/QQ\//i)
  return isQQ
}

export function isMobile () {
  const isMobile = !!u.match(/AppleWebKit.*Mobile.*/)
  return isMobile
}

export function getScrollTop () {
  var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0
　if (document.body) {
　  bodyScrollTop = document.body.scrollTop
　}
　if (document.documentElement) {
　  documentScrollTop = document.documentElement.scrollTop
　}
　scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
　return scrollTop
}

export function getScrollHeight () {
  var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0
  if(document.body){
    bodyScrollHeight = document.body.scrollHeight
　}
　if(document.documentElement){
    documentScrollHeight = document.documentElement.scrollHeight
　}
　scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
　return scrollHeight
}

export function getWindowHeight () {
  var windowHeight = 0
  if(document.compatMode == "CSS1Compat"){
    windowHeight = document.documentElement.clientHeight
  }else{
    windowHeight = document.body.clientHeight
　}
　return windowHeight
}

export function formatMultiNum (num) {
  if(!num) {
    return 0
  } else {
    const numArr = num.toString().split(".")
    const intNum = numArr.length>1 ? numArr[1] : numArr[0]
    const reverseNums = intNum.split("").reverse()
    const len = reverseNums.length
    let newNums = []

    reverseNums.forEach((n, index) => {
      if((index+1)%3 === 0) {
        newNums.push(n)
        if(index+1 !== len) {
          newNums.push(",")
        }
      } else {
        newNums.push(n)
      }
    })

    return newNums.reverse().join("")
  }
}

export function zipImage (image, zipWidth) {
  if(!image || !image.src) {
    return ''
  }

  const baseWidth = 750
  let src = ''
  let newSrc = ''
  if(typeof image === 'string') {
    src = image
    const width = zipWidth || baseWidth
    newSrc = formatZipImage(src, width)
    return newSrc
  }

  if(typeof image === 'object') {
    src = image.src
    const imageWidth = image.width
    const myWidth = imageWidth<baseWidth?imageWidth:baseWidth
    const width = zipWidth || myWidth
    newSrc = formatZipImage(src, width)
    return {
      src: newSrc,
      width: image.width,
      height: image.height
    }
  }
  
  return image
}

function formatZipImage (src, width) {
  const stuffIndex = src.lastIndexOf('.')
  const stuff = src.substring(stuffIndex)
  const stuffStr = stuff.toLowerCase()

  if(stuffStr == ".jpg" || stuffStr == ".jpeg" || stuffStr == ".png" || stuffStr == ".webp") {
    return `${src}@0o_0l_${width}w_90q`
  } else if (stuffStr == ".gif") {
    return `${src}?x-oss-process=image/resize,w_${width}/quality,q_90`
  } else {
    return src
  }
}



// WEBPACK FOOTER //
// ./static/util/index.js